import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ArrowDownTrayIcon from '../../elements/icons/ArrowDownTrayIcon'
import ChevronIcon from '../../elements/icons/ChevronIcon'
// import EmailAtIcon from '../../elements/icons/EmailAtIcon'
import ModalActionButton from '../../elements/ModalActionButton';
import { ERROR } from '../../../store/types';
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';

const StudentResult = ({student, resultId, close}) => {
    const [result, setResult] = React.useState(null)
    const [loading, setLoading] = React.useState(true)
    const [downloading, setDownloading] = React.useState(false)
    const [sectionsOpen, setSectionsOpen] = React.useState({
        subjectBreakdown: true,
        areasOfStrength: true,
        areasNeedingImprovement: true,
        traits: true,
        overallComments: true
    })

    const dispatch = useDispatch()
    
    useEffect(() => {
        const fetchResult = async () => {
            try {
                setLoading(true)
                const headers = authHeader()

                const response = await axios.get(`${baseUrl}/student-results/${resultId}?expand=subjectBreakdown.subject,traits.trait,term,academicSession,compiledBy`, { headers })
                setResult(response.data.data)
            } catch (error) {
                dispatch({
                    type: ERROR,
                    error
                })
            } finally {
                setLoading(false)
            }            
        }
        fetchResult()
    }, [dispatch, resultId])

    const toggleSection = (sectionKey) => {
        setSectionsOpen(previous => ({ ...previous, [sectionKey]: !previous[sectionKey] }))
    }

    const SectionHeader = ({ title, sectionKey }) => (
        <button onClick={() => toggleSection(sectionKey)} className='w-full flex items-center justify-between mb-3 text-left'>
            <span className='flex items-center gap-x-2 text-sm text-gray-600 font-space-grotesk font-medium'>
                <ChevronIcon className={`w-4 h-4 transition duration-200 ${sectionsOpen[sectionKey] ? 'rotate-[270deg]' : 'rotate-180'}`} />
                {title}
            </span>
            <span className='text-xs text-gray-400'>{sectionsOpen[sectionKey] ? 'Hide' : 'Show'}</span>
        </button>
    )

    const subjectBreakdown = result?.subjectBreakdown || []
    const subjectName = (subject) => subject?.name || subjectBreakdown.find(entry => entry.subject?._id === subject)?.subject?.name || subject || 'Unknown subject'
    const overallAverage = subjectBreakdown.length > 0
        ? subjectBreakdown.reduce((total, entry) => total + (entry.averageScore || 0), 0) / subjectBreakdown.length
        : null
    const compilationDate = result?.createdAt
        ? new Date(result.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
        : 'Not available'

    const downloadResult = async () => {
        if (downloading) return

        try {
            setDownloading(true)
            const response = await axios.get(`${baseUrl}/student-results/${resultId}/pdf`, {
                headers: authHeader(),
                responseType: 'blob'
            })

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `student-result-${resultId}.pdf`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        } finally {
            setDownloading(false)
        }
    }

    return (
        <div className="w-full">
            <div className='pb-3 mb-2'>
                <div className="w-full mx-auto">
                    <div className='w-full flex items-start justify-between'>
                        <div className='w-2/3'>
                            <h4 className='font-medium text-lg mb-1 text-gray-600'>Term Result for {student.fullName}</h4>
                            <div className=''>
                            <p className='text-gray-600 text-sm'>
                                All academic records for this student are displayed below.
                            </p>
                            </div>
                        </div>
                        {/* <div className='w-full flex flex-row-reverse gap-x-[5px]'>
                            {<button onClick={()=>{}} disabled={false} className='rounded-[8px] w-max text-sm text-gray-600 transition duration-200 px-4 py-3 bg-gray-100 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2 font-space-grotesk font-semibold'>
                                <span className='flex items-center gap-x-2'>
                                    <ArrowDownTrayIcon className='w-5 h-5' />
                                    Download Result (.pdf)
                                </span>
                            </button>}

                            {<button onClick={()=>{}} disabled={false} className='rounded-[8px] w-max text-sm text-gray-600 transition duration-200 px-4 py-3 bg-gray-100 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2 font-space-grotesk font-semibold'>
                                <span className='flex items-center gap-x-2'>
                                    <EmailAtIcon className='w-5 h-5' />
                                    Send as Email
                                </span>
                            </button>}
                        </div> */}
                    </div>
                </div>
            </div>
            {/* Result body */}
            <div className="w-full">
                {loading ? <div className='py-12 text-center text-sm text-gray-400'>Loading result...</div> : !result ? null : (
                    <div className='w-full flex flex-col gap-y-6'>
                        <div className='w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Academic Session</p><p className='text-sm font-semibold text-gray-700 mt-1'>{result.academicSession?.name || result.academicSession || 'Not available'}</p></div>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Term</p><p className='text-sm font-semibold text-gray-700 mt-1'>{result.term?.name || result.term || 'Not available'}</p></div>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Term Total / Average</p><p className='text-sm font-semibold text-gray-700 mt-1'>{result.assessmentScores?.termTotal?.toFixed(2)} &middot; {result.assessmentScores?.termAverage?.toFixed(2)}%</p></div>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'><p className='text-xs text-gray-500 font-space-grotesk'>Overall Average</p><p className='text-sm font-semibold text-gray-700 mt-1'>{overallAverage?.toFixed(2) || '0.00'}%</p></div>
                        </div>

                        <div className='w-full flex items-center gap-x-3'>
                            <span className={`inline-block text-xs px-2 py-1 rounded font-outfit ${result.finalTermResult ? 'bg-green-600 text-green-800 bg-opacity-10' : 'bg-gray-600 text-gray-500 bg-opacity-10'}`}>{result.finalTermResult ? 'Final Term Result' : 'Not Final Term Result'}</span>
                            <span className={`inline-block text-xs px-2 py-1 rounded font-outfit ${result.promoted ? 'bg-green-600 text-green-800 bg-opacity-10' : 'bg-gray-600 text-gray-500 bg-opacity-10'}`}>{result.promoted ? 'Promoted' : 'Not Promoted'}</span>
                        </div>

                        <div className='w-full'>
                            <SectionHeader title='Subject Breakdown' sectionKey='subjectBreakdown' />
                            {sectionsOpen.subjectBreakdown && <div className='w-full border border-gray-100 rounded-[8px] overflow-x-auto'>
                                <table className='w-full text-sm'>
                                    <thead><tr className='bg-gray-50 text-left text-xs text-gray-500 font-space-grotesk'><th className='px-4 py-3 font-medium'>Subject</th><th className='px-4 py-3 font-medium'>Assessments</th><th className='px-4 py-3 font-medium'>Total Score</th><th className='px-4 py-3 font-medium'>Average</th><th className='px-4 py-3 font-medium'>Grade</th><th className='px-4 py-3 font-medium'>Status</th></tr></thead>
                                    <tbody className='divide-y divide-gray-100'>{subjectBreakdown.map(entry => <tr key={entry._id}>
                                        <td className='px-4 py-3 text-gray-700 font-medium'>{entry.subject?.name || entry.subject}</td>
                                        <td className='px-4 py-3 text-gray-500'>{entry.uploadedAssessmentCount} of {entry.assessmentCount}</td><td className='px-4 py-3 text-gray-500'>{entry.totalScore?.toFixed(2)}</td><td className='px-4 py-3 text-gray-500'>{entry.averageScore?.toFixed(2)}%</td><td className='px-4 py-3 text-gray-500'>{entry.grade}</td>
                                        <td className='px-4 py-3'><span className={`inline-block text-xs px-2 py-1 rounded font-outfit ${entry.passingGrade ? 'bg-green-600 text-green-800 bg-opacity-10' : 'bg-red-600 text-red-800 bg-opacity-10'}`}>{entry.passingGrade ? 'Passing' : 'Failing'}</span>{entry.needsImprovement && <span className='inline-block ml-2 text-xs px-2 py-1 rounded font-outfit bg-amber-600 text-amber-800 bg-opacity-10'>Needs Improvement</span>}</td>
                                    </tr>)}</tbody>
                                </table>
                            </div>}
                        </div>

                        {['areasOfStrength', 'areasNeedingImprovement'].map(areaKey => <div key={areaKey} className='w-full rounded-[8px] border border-gray-100 p-4'>
                            <SectionHeader title={areaKey === 'areasOfStrength' ? 'Areas of Strength' : 'Areas Needing Improvement'} sectionKey={areaKey} />
                            {sectionsOpen[areaKey] && <div className='flex flex-col gap-y-3'>{result[areaKey]?.subjects?.length ? result[areaKey].subjects.map(item => <div key={item._id} className='grid grid-cols-1 md:grid-cols-[35%_1fr] gap-2 rounded-[8px] bg-gray-50 p-3'>
                                <p className='text-sm font-medium text-gray-700'>{subjectName(item.subject)}</p><p className='text-sm text-gray-500'>{item.comment || 'No comment provided.'}</p>
                            </div>) : <p className='text-xs text-gray-400'>No records recorded.</p>}</div>}
                        </div>)}

                        <div className='w-full rounded-[8px] border border-gray-100 p-4'><SectionHeader title='Traits' sectionKey='traits' />{sectionsOpen.traits && (result.traits?.length ? <div className='w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4'>{result.traits.map(item => <div key={item._id} className='rounded-[8px] bg-gray-50 p-3 flex items-center justify-between'><p className='text-sm font-medium text-gray-700'>{item.trait?.name || item.trait}</p><span className={`px-3 py-1 rounded text-xs font-space-grotesk font-semibold ${item.score > 10 || item.score < 5 ? 'bg-red-600/10 text-red-600' : item.score < 7 ? 'bg-yellow-500/20 text-yellow-800' : 'bg-green-500/10 text-green-600'}`}>{item.score}</span></div>)}</div> : <p className='text-xs text-gray-400'>No trait records yet.</p>)}</div>

                        <div className='w-full rounded-[8px] border border-gray-100 p-4'><SectionHeader title='Overall Comments' sectionKey='overallComments' />{sectionsOpen.overallComments && (result.overallComments?.length ? <div className='flex flex-col gap-y-2'>{result.overallComments.map((comment, index) => <p key={index} className='rounded-[8px] bg-gray-50 p-3 text-sm text-gray-600'>{comment}</p>)}</div> : <p className='text-xs text-gray-400'>No overall comments recorded.</p>)}</div>

                        <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-4'>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'>
                                <p className='text-xs text-gray-500 font-space-grotesk'>Compiled By</p>
                                <p className='text-sm font-semibold text-gray-700 mt-1'>{result.compiledBy?.fullName || 'Staff Profile not found'}</p>
                            </div>
                            <div className='rounded-[8px] border border-gray-100 bg-gray-50 p-4'>
                                <p className='text-xs text-gray-500 font-space-grotesk'>Compilation Date</p>
                                <p className='text-sm font-semibold text-gray-700 mt-1'>{compilationDate}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={<span className='flex items-center gap-x-2'>
                        <ArrowDownTrayIcon className='w-5 h-5' />
                        Download Result (.pdf)
                    </span>}
                    buttonAction={downloadResult}
                    processing={downloading}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-xl transition duration-200 hover:bg-opacity-50 hover:bg-secondary/10 focus:outline-none"
                    onClick={close}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default StudentResult